import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import footerImage from "../../assets/images/softindex-website-logo-footer1.png";
import consumerRightsImageA from "../../assets/images/icons/anpc/anpc-solutionarea-alternativa-litigiilor-a.png";
import consumerRightsImageB from "../../assets/images/icons/anpc/anpc-solutionarea-alternativa-litigiilor-b.png";

export default function Footer({ variant = "default" }) {
  const { t } = useTranslation("footer");

  return (
    <footer
      className={`${styles.footer} ${
        variant === "portal" ? styles.footerPortal : ""
      }`}
    >
      <div className={styles.container}>
        <div className={styles.footerSection}>
          <img
            src={footerImage}
            alt="Softindex Logo"
            className={styles.footerLogoImage}
          />
          <p className={styles.footerText}>{t("description")}</p>
        </div>

        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>{t("quickLinks")}</h3>
          <div className={styles.linksList}>
            <Link to="/" className={styles.footerLink}>
              {t("home")}
            </Link>
            <Link to="/products" className={styles.footerLink}>
              {t("services")}
            </Link>
            <Link to="/billing" className={styles.footerLink}>
              {t("technologies")}
            </Link>
            <Link to="/support" className={styles.footerLink}>
              {t("portfolio")}
            </Link>
            <Link to="/profile" className={styles.footerLink}>
              {t("whyUs")}
            </Link>
          </div>
        </div>

        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>{t("contactUs")}</h3>
          <div className={styles.contactInfo}>
            <svg
              className={styles.icon}
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            <span>contact@softindex.ro</span>
          </div>
          <div className={styles.contactInfo}>
            <svg
              className={styles.icon}
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
            <span>+40 (757) 217-448</span>
          </div>
        </div>

        <div className={styles.footerSection}>
          <h3 className={styles.footerHeading}>{t("followUs")}</h3>
          <div className={styles.socialIcons}>
            <a
              href="https://www.facebook.com/"
              aria-label="Facebook"
              className={`${styles.socialLink} ${styles.facebookLink}`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a
              href="https://x.com/"
              aria-label="X (Twitter)"
              className={`${styles.socialLink} ${styles.xLink}`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/"
              aria-label="Instagram"
              className={`${styles.socialLink} ${styles.instagramLink}`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.204-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.012-3.584.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072C3.58 0.234 2.31 1.5 2.163 3.581.146 6.041.134 6.468.134 9.5c0 3.031.012 3.458.072 4.947.147 2.081 1.417 3.351 3.498 3.498.058 1.28.07 1.688.07 4.947 0 3.259-.014 3.667-.072 4.947-.147 2.081-1.417 3.351-3.498 3.498-1.28.058-1.688.07-4.947.07-3.031 0-3.458-.012-4.947-.072-2.081-.147-3.351-1.417-3.498-3.498-.058-1.28-.07-1.688-.07-4.947 0-3.259.014-3.667.072-4.947.147-2.081 1.417-3.351 3.498-3.498 1.28-.058 1.688-.07 4.947-.07zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162S15.403 5.838 12 5.838zm0 10.162c-2.209 0-4-1.79-4-4s1.791-4 4-4 4 1.79 4 4-1.791 4-4 4zm6.826-9.229c0 1.04-.841 1.88-1.88 1.88s-1.88-.84-1.88-1.88c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88z" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/"
              aria-label="LinkedIn"
              className={`${styles.socialLink} ${styles.linkedinLink}`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <hr className={styles.horizontalLine} />
      <div className={styles.copyright}>
        <div className={styles.copyrightContent}>
          <p>
            &copy; {new Date().getFullYear()} Softindex. {t("copyright")}
          </p>
          <div className={styles.consumerBadges}>
            <a
              href="https://consumer-redress.ec.europa.eu/site-relocation_en?event=main.home.chooseLanguage"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("consumerRights.european")}
            >
              <img
                src={consumerRightsImageA}
                alt={t("consumerRights.anpcAlt")}
                loading="lazy"
                width="250"
                height="62"
                className={styles.consumerBadge}
              />
            </a>
            <a
              href="https://reclamatiisal.anpc.ro/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("consumerRights.anpcOnline")}
            >
              <img
                src={consumerRightsImageB}
                alt={t("consumerRights.anpcOnlineAlt")}
                loading="lazy"
                width="250"
                height="62"
                className={styles.consumerBadge}
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
